import {
  SET_THEME,
  SHUFFLE_THEMES
} from '../constants/actions';
import {
  THEMES,
  QUOTE_QUANTITY
} from '../constants/config';
import shuffle from '../libs/shuffle';

function range(start, end) {
  const foo = [];
  for (let i = start; i <= end; i++) {
    foo.push(i);
  }
  return foo;
}

function getQuotes() {
  return shuffle(range(1, THEMES)).splice(0, QUOTE_QUANTITY);
}

export function setTheme(state = 'default', { type, payload }) {
  switch (type) {
    case SET_THEME:
      if (payload !== 'default') {
        return payload;
      }
      return 'default';
    default:
      return state;
  }
}

export function shuffleThemes(state = getQuotes(), { type }) {
  switch (type) {
    case SHUFFLE_THEMES:
      return getQuotes();
    default:
      return state;
  }
}



/** WEBPACK FOOTER **
 ** ./src/js/reducers/reducer-themes.js
 **/